import { useEffect, useState, KeyboardEvent } from "react";
import { observer } from "mobx-react";
import { Modal, Form, Input, Radio } from "antd";
import authVM from "logic/src/businesses/auth/vm";
import ResetPassword from "./components/ResetPassword";
import Login from "./components/Login";

import styles from "./index.module.scss";

const LoginDialog: React.FC<{
  visible: boolean;
  onFinishLogin: () => void;
  onFinishResetPassword: () => void;
  onClose: () => void;
}> = ({ visible, onFinishLogin, onFinishResetPassword, onClose }) => {
  const [resetMode, setResetMode] = useState<boolean>(false);

  useEffect(() => {
    if (visible) {
      setResetMode(false);
      authVM.smsCode.resetCode();
    }
    // vm.setLoginForm(form);
    // vm.setResetPasswordForm(resetForm);
  }, [visible]);

  return (
    <Modal
      className={styles.container}
      wrapClassName={styles.modalWrapper}
      width={444}
      centered
      closable={false}
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <div className={styles["dialog-container"]}>
        <div className={styles["dialog-title"]}>欢迎登录商量</div>
        {resetMode ? (
          <ResetPassword
            onFinishResetPassword={onFinishResetPassword}
            onGotoLogin={() => setResetMode(false)}
          />
        ) : (
          <Login
            onFinishLogin={onFinishLogin}
            onGotoResetPassword={() => setResetMode(true)}
          />
        )}
      </div>
    </Modal>
  );
};

export default observer(LoginDialog);
